export default __webpack_public_path__ + "static/media/options.09682eca.png";